import { useState, useRef } from 'react'
import { toast } from 'react-toastify';

// Components
import CModal from 'components/v1/modal';
import Button from 'components/v1/Button';

// Assets
import { ReactComponent as IconX } from "assets/x-black.svg"
import { ReactComponent as IInfo } from "assets/info-blue.svg"
import { ReactComponent as ILampiran } from "assets/paperclip.svg"
import { ReactComponent as IFileLampiran } from "assets/file-lampiran.svg"

const CInputFile = ({ label, file, setFile }) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const selectedFile = files[0];

      // Check file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      const fileType = selectedFile.type;

      if (!allowedTypes.includes(fileType)) {
        toast.error('Format file harus JPG, PNG, JPEG, atau PDF');
        return;
      }

      // Check file size (5MB = 5 * 1024 * 1024 bytes)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes

      if (selectedFile.size > maxSize) {
        toast.error('Ukuran file tidak boleh lebih dari 5MB');
        return;
      }

      setFile(selectedFile);
    }
  };

  return (
    <div className='py-2 flex items-center justify-between'>
      <p className='text-[13px]'>{label}<span className='text-[#FD4949]'>*</span></p>

      {!!file ? (
        <div className='w-[255px] flex items-center p-2 justify-between bg-[#E6FAF0] rounded'>
          <div className='flex items-center'>
            <IFileLampiran className='w-4 h-4 object-contain mr-2' />
            <span className='text-[11px]'>{file.name}</span>
          </div>
          <button onClick={handleClick} className='text-[11px] text-[#0011F8] underline'>Ubah</button>
          <input
            type="file"
            ref={fileInputRef}
            className="hidden"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={handleFileChange}
          />
        </div>
      ) : (
        <div onClick={handleClick} className='w-[255px] flex items-center p-2 justify-center rounded border-[0.5px] border-dashed border-[#808285]'>
          <ILampiran className='w-4 h-4 object-contain mr-2' />
          <span className='text-[11px] text-[#0011F8] underline'>Tambah File</span>
          <input
            type="file"
            ref={fileInputRef}
            className="hidden"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={handleFileChange}
          />
        </div>
      )}
    </div>
  )
}

const ModalUnggahLampiran = ({ onSubmit, batchId, isUploadLampiran, ...props }) => {
  const [agreementFile, setAgreementFile] = useState(null);
  const [integrityFile, setIntegrityFile] = useState(null);
  const [otherFile, setOtherFile] = useState(null);

  return (
    <CModal {...props}>
      <div className='w-[450px] rounded'>
        <div className='py-2 px-6 flex items-center justify-between border-b-[0.5px] border-solid border-[#D8D8D9]'>
          <p className='text-[17px] font-semibold leading-[27.5px] tracking-[-0.4px] mr-2'>Unggah Lampiran</p>
          <IconX onClick={props.onRequestClose} width="14px" height="14px" className='cursor-pointer' />
        </div>
        <div className='py-2 px-6 rounded-t'>
          {isUploadLampiran && <CInputFile label="Pakta Integritas" file={integrityFile} setFile={setIntegrityFile} />}
          {isUploadLampiran && <CInputFile label="Perjanjian Kemitraan" file={agreementFile} setFile={setAgreementFile} />}
          <CInputFile label="Lainnya" file={otherFile} setFile={setOtherFile} />
        </div>
        <div className='py-2 px-6 bg-[#EBF0F7] flex items-center justify-center'>
          <IInfo className='w-4 h-4 object-contain mr-2' alt='info' />
          <p className='text-[11px] text-[#3268AE]'>Unggah file dengan format JPG, PNG, atau PDF. Ukuran maksimal 5 MB.</p>
        </div>
        <div className='flex items-center justify-end pt-1 pb-4 px-6 border-t-[0.5px] border-solid border-[#D8D8D9] rounded-b'>
          <Button onClick={props.onRequestClose} text="Kembali" className="mr-2" type="secondary" />
          <Button disabled={isUploadLampiran && (!agreementFile || !integrityFile)} onClick={() => { onSubmit(batchId, otherFile, agreementFile, integrityFile) }} text="Daftarkan" />
        </div>
      </div>
    </CModal>
  )
}

export default function Wrapper({ isOpen, onAfterOpen, onRequestClose, ...props }) {
  if (!isOpen) return null;
  return <ModalUnggahLampiran isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} {...props} />
}